@if (runData) {
    <div class="d-flex flex-column gap-3">
        <!-- name -->
        <div>
            <label for="teamNameLabel">Name</label>
            <dx-text-box [(value)]="team.name"
                         (valueChange)="onEntitiesChanged([team])"
                         [adaptValidateEntity]="team"
                         adaptValidateEntityProperty="name"
                         [readOnly]="submitting"
                         data-test="team-name-input"
                         id="teamNameLabel"></dx-text-box>
        </div>

        <!-- leader -->
        <div>
            <label for="inputTeamLeader">{{ teamLeaderLabel$ | async }}</label>
            <adapt-select-person [person]="team.teamLeaderPerson"
                                 (personChange)="onTeamLeaderChanged($event)"
                                 [required]="true"
                                 [disabled]="isPrivateNonStakeholderManagerOrCoach || submitting"
                                 [userTypes]="allowedUserTypes"
                                 data-test="team-leader-input"
                                 id="inputTeamLeader"></adapt-select-person>
        </div>

        <div>
            <label>Type</label>
            <adapt-select-team-type [(teamTypeConfiguration)]="team.teamTypeConfiguration"
                                    (teamTypeConfigurationChange)="onTeamTypeChanged($event)"
                                    [disabled]="submitting"
                                    data-test="select-team-type"></adapt-select-team-type>
            <button *adaptIfAuthorised="ConfigureOrganisation"
                    adaptButton="configureLink"
                    [disabled]="submitting"
                    class="mt-1"
                    (click)="onConfigureOrganisationGroupTypesClicked()">Configure organisation group types</button>
        </div>

        <div class="d-flex flex-column gap-1">
            <label>Location</label>
            <p class="mb-1">Where should this {{ teamTypeName?.toLocaleLowerCase() }} sit?</p>
            <adapt-edit-team-locations #editTeamLocations
                                       [team]="team"
                                       [disabled]="submitting"
                                       [showChildSelection]="false"
                                       [showLabel]="false"
                                       (entitiesPopulated)="addEntitiesToConfirm($any($event))"
                                       (entityChanged)="onTeamLocationEntityAdded($any($event))"></adapt-edit-team-locations>
        </div>

        <div class="d-flex flex-column gap-2">
            <label>Options</label>
            <dx-check-box [value]="team.isPrivate"
                          (valueChange)="onPrivateTeamChanged($any($event))"
                          [disabled]="!team.teamLeaderPerson || isOwnerTeam || submitting"
                          text="Set as private"></dx-check-box>
            @if (isPrivateNonStakeholderManagerOrCoach) {
                <div class="alert alert-info p-2">
                    Only members of a private group and coaches will have access to the group.
                    When creating a private group, the person creating the group is automatically set as the leader.
                </div>
            }

            @if (isCoachOrStakeholderManager && (canCreateOwnerTeam || canCreateLeadersTeam)) {
                <div class="border rounded-2 p-2">
                    <label>Coach options</label>
                    <div class="form-group d-flex flex-column gap-1 mt-1 mb-0">
                        @if (canCreateOwnerTeam) {
                            <div class="d-flex flex-row align-items-center">
                                <dx-check-box [value]="createAsOwnerTeam"
                                              [disabled]="createAsLeadershipTeam || submitting"
                                              (valueChange)="onOwnerTeamCheckChanged($any($event))"
                                              text="Create as Owner team"
                                              data-test="owner-team-checkbox"></dx-check-box>
                                <i class="fal fa-info-circle"
                                   [adaptTooltip]="ownerTeamTooltip"
                                   [adaptTooltipIsHtml]="true"
                                   tooltipContentClasses="text-start"></i>
                            </div>
                        }
                        @if (canCreateLeadersTeam) {
                            <div class="d-flex flex-row align-items-center">
                                <dx-check-box [value]="createAsLeadershipTeam"
                                              [disabled]="createAsOwnerTeam || submitting"
                                              (valueChange)="onLeadershipTeamCheckChanged($any($event))"
                                              text="Create as Organisation Leaders team"
                                              data-test="organisation-leaders-team-checkbox"></dx-check-box>
                                <i class="fal fa-info-circle"
                                   [adaptTooltip]="leadersTeamTooltip"
                                   [adaptTooltipIsHtml]="true"
                                   tooltipContentClasses="text-start"></i>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
}

<ng-template #createTeamButton>
    <adapt-add-team-create-team-button [instance]="this"></adapt-add-team-create-team-button>
</ng-template>
